import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo, useEffect, useState } from "react";
import { inkapi } from '../../middleware/interceptor.js';

export const MatTable = ({ columns, data }) => {


  console.log(columns, data, "dataBind");
  // const table = useMaterialReactTable({
  //   data: data,
  //   columns,
  //   // createDisplayMode: 'row', // ('modal', and 'custom' are also available)
  //   // editDisplayMode: 'cell', // ('modal', 'row', 'table', and 'custom' are also available)
  //   // enableCellActions: true,
  //   // enableClickToCopy: 'context-menu',
  //   enableColumnPinning: false,
  //   // enableEditing: true,
  //   // enableRowActions: true,
  //   enableKeyboardShortcuts: false,
  //   enableColumnActions: false,
  //   enableColumnFilters: false,
  //   enablePagination: true,
  //   enableSorting: false,
  //   muiTableBodyRowProps: { hover: false },
  //   enableFullScreenToggle: false,
  //   enableDensityToggle: false,
  //   enableHiding: false,
  //   muiTableBodyRowProps: { hover: true },
  //   initialState: { pagination: { pageSize: 25, pageIndex: 0 } },

  //   muiTableProps: {
  //     sx: {
  //       border: "1px solid rgba(81, 81, 81, .5)",
  //       caption: { captionSide: "top" },
  //     },
  //   },
  //   muiTableHeadCellProps: {
  //     sx: {
  //       border: "3px solid  rgba(81, 81, 81, .5)",
  //       backgroundColor: "white",
  //       fontStyle: "italic",
  //       fontWeight: "bold",
  //     },
  //   },
  //   muiTableBodyCellProps: {
  //     sx: {
  //       border: "1px solid rgba(81, 81, 81, .5)",
  //     },
  //   },
  // });


  const table = useMaterialReactTable({
    data: data,
    columns: columns,
    enableGlobalFilter: true,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableColumnVisibility: false,
    enableHiding: false,
    defaultDisplayColumn: {
      enableColumnOrdering: true,
      enableColumnResizing: true,
      minSize: 100,
    },
    initialState: { pagination: { pageSize: 25, pageIndex: 0 } },

  });



  return (
    <>
      <div className="flex justify-center">
        <div className="custom_material">
          <MaterialReactTable muiTablePaginationProps={{
            rowsPerPageOptions: [5, 10, 20],
          }} table={table} />
        </div>
      </div>


    </>
  );
};

export default MatTable;
